import { ActionTree } from 'vuex';
import { PartyState } from './types';
import { RootState, Party } from '@/types';
import { partyService } from '@/services/party.services';
import {claimService} from '@/services/claim.services';


export const actions: ActionTree<PartyState, RootState> = {
    get({ dispatch }, { id = '' }): any {
        dispatch('getParty', { id });
        dispatch('getComments', { id });
        dispatch('getAttachments', { id });
        dispatch('getContacts', { id });
    },
    getParty({ commit }, { id = '' }): any {
        commit('setLoading');
        partyService.show(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setData', payload);
        }, (error) => {
            commit('setError', error);
        });
    },
    updateParty({ dispatch }, { party }): any {
        partyService.put(party.id, party)
            .then((response) => {
                dispatch('get', { id: party.id });
            });
    },
    getComments({ commit }, { id = '' }): any {
        commit('setCommentsLoading');
        partyService.getComments(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setCommentsData', payload);
        }, (error) => {
            commit('setCommentsError', error);
        });
    },
    postComment({ dispatch }, { id, comment }): any {
        let post;
        if (comment.id) {
            post = partyService.putComment(comment.id, comment);
        } else {
            post = partyService.postComment(id, comment);
        }
        post.then((response) => {
            const commentId: string = response && response.data && response.data.id;
            if (comment.attachments && comment.attachments.length > 0) {
                for (const attachment of comment.attachments) {
                    partyService.postAttachment(commentId, attachment)
                        .then(() => {
                            dispatch('getComments', { id });
                            dispatch('getAttachments', { id });
                        });
                }
            } else {
                dispatch('getComments', { id });
            }
        });
    },
    getAttachments({ commit }, { id = ''}): any {
        commit('setAttachmentsLoading');
        partyService.getAttachments(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setAttachmentsData', payload);
        }, (error) => {
            commit('setAttachmentsError', error);
        });
    },
    getContacts({ commit }, { id = '' }): any {
        commit('setContactsLoading');
        partyService.getContacts(id)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setContactsData', payload);
        }, (error) => {
            commit('setContactsError', error);
        });
    },
    postContact({ dispatch }, { id, contact }): any {
        let post;
        if (contact.id) {
            post = partyService.putContact(contact.id, contact);
        } else {
            post = partyService.postContact(id, contact);
        }
        post.then((response) => {
            const contactId: string = response && response.data && response.data.id;
            dispatch('getContacts', { id });
        });
    },
};
